module.exports = __webpack_public_path__ + "img/Maravilloso.290d7bcb.svg";